import {type Optional} from '@logistics-frontend/types'
import type {ButtonProps, RadioProps} from '@yandex-delivery/blocks'
import {useState} from 'react'

import {i18n} from 'src/shared/config'
import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'

import type {Props as ChangeCardModalProps} from '../ChangeCardModal/types'
import type {Props} from './types'
import {getUnauthorizedButtonProps, getUnauthorizedRadioProps} from './utils'

export function useProps(props: Props) {
  const {card, showRadio, getBody, onChange, unauthorized} = props
  const [opened, setOpened] = useState(false)
  const openHandler = setOpened.bind(null, true)
  const closeHandler = setOpened.bind(null, false)
  const handleReachGoal = useFormUserEventHandler()

  const handleOpenChangeCardModal = () => {
    openHandler()
    handleReachGoal(OrderEventGoal.SelectPaymentCard)
  }

  const buttonProps: ButtonProps = Object.assign<ButtonProps, ButtonProps | undefined, ButtonProps | undefined>(
    {
      onPress: handleOpenChangeCardModal,
      shape: 'circle',
      size: 'xs',
      textVariant: 'caption1',
      type: 'button',
      variant: 'action',
      children: i18n('order-form.payments-widget.card.select', 'Выбрать'),
    },
    card && {
      variant: 'outline',
      children: i18n('order-form.payments-widget.card.change', 'Изменить'),
    },
    unauthorized ? getUnauthorizedButtonProps(unauthorized) : undefined,
  )
  const radioProps: Optional<RadioProps<string>> = showRadio
    ? Object.assign(
        {
          checked: Boolean(card),
          onClick: openHandler,
        },
        unauthorized ? getUnauthorizedRadioProps(unauthorized) : undefined,
      )
    : undefined
  const changeCardModalProps: Optional<ChangeCardModalProps> = opened
    ? {
        card,
        getBody,
        onChange,
        onClose: closeHandler,
      }
    : undefined

  return {
    buttonProps,
    radioProps,
    changeCardModalProps,
  } as const
}
